module.exports = __webpack_public_path__ + "img/logo.871b21a0.png";